import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WorkOrderItemCard } from "./WorkOrderItemCard";
import { WorkOrderDetailsCard } from "./WorkOrderDetailsCard";

export const ProcessWorkOrderCard = ({ classes, match, history }) => {
  const dispatchRa = useDispatch();
  const workOrderId = match?.params?.id;
  const lastSelectedAisleState = useSelector(
    (state) => state.data.lastSelectedAisle,
  );

  useEffect(() => {
    const lastUsedWorkOrderId = lastSelectedAisleState?.shipmentId;
    if (!lastUsedWorkOrderId || lastUsedWorkOrderId === workOrderId) {
      return;
    }
    // Reset aisle memory only when entering a work-order context.
    // Keeps aisle memory while switching inventories/add-location inside same work order.
    dispatchRa({
      type: "SET_LAST_SELECTED_AISLE",
      payload: { aisle: null, shipmentId: null },
    });
  }, [dispatchRa, workOrderId, lastSelectedAisleState]);

  return (
    <>
      <Route
        path={`${match.path}/inventories/:id`}
        render={(props) => <WorkOrderItemCard {...props} />}
      />
      <Route
        path={`${match.path}`}
        exact
        render={(props) => (
          <WorkOrderDetailsCard classes={classes} history={history} {...props} />
        )}
      />
    </>
  );
};

export const ProcessInboundShipmentCard = ProcessWorkOrderCard;
